module.exports = __webpack_public_path__ + "officialStatic/img/about.d1f2e1b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/about/about.png
// module id = EeLt
// module chunks = 0